// 开发
// window.g = {
//   API_URL: 'http://192.168.0.117:5081/yixg4g/centerserver',   //银翔测试后台地址
//   LIVE_URL: "192.168.0.175:5052",           //银翔实时视频地址
//   Talk_URL: "192.168.0.175:5054",           //银翔对讲地址
//   Bmap: "192.168.0.97:5054",           //银翔对讲地址
// }

// 生产
window.g = {
  API_URL: 'http://192.168.0.117:5081/yixg4g/centerserver',   //银翔测试后台地址
  LIVE_URL: location.hostname +":5052",           //银翔实时视频地址
  Talk_URL: location.hostname+":5054",           //银翔对讲地址
}


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 1